import type { ReactElement } from 'react';
import { List } from '@noah-labs/fe-shared-ui-components';
import type {
  MarkdownRemarkFrontmatterHeaderMenuHeaderLinks,
  Maybe,
} from '../../../generated/types';
import { LanguageAccordion } from '../i18n/LanguageAccordion';
import { MobileMenuItem } from './MobileMenuItem';

type PpMobileMenu = {
  menu: Maybe<Maybe<MarkdownRemarkFrontmatterHeaderMenuHeaderLinks>[]> | undefined;
  withLanguageSwitch?: boolean;
};

export function MobileMenu({ menu, withLanguageSwitch }: PpMobileMenu): ReactElement {
  return (
    <List disablePadding>
      {menu?.map((menuItem) => {
        const hasSublinks = menuItem?.headerURL === 'blank';
        return (
          <MobileMenuItem
            key={menuItem?.headerLabel}
            hasSublinks={hasSublinks}
            menuItem={menuItem}
          />
        );
      })}
      {withLanguageSwitch && <LanguageAccordion />}
    </List>
  );
}
